<ig-a11y-status></ig-a11y-status>

<ig-loader size="fullscreen" *ngIf="(isLoggingIn$ | async) || (isAppBusy$ | async)" [message]="!!(loadingMessage) ? ( loadingMessage | translate) : undefined"></ig-loader>
<router-outlet></router-outlet>

